import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonalNotificationsService } from './personal-notifications.service';
import { PersonalNotificationsIconComponent } from './personal-notifications-icon/personal-notifications-icon.component';
import { PersonalNotificationsListComponent } from './personal-notifications-list/personal-notifications-list.component';
import { PersonalNotificationsListItemComponent } from './personal-notifications-list-item/personal-notifications-list-item.component';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';

@NgModule({
    imports: [CommonModule, UtilitiesModule, FiProfileIconModule],
    declarations: [
        PersonalNotificationsIconComponent,
        PersonalNotificationsListComponent,
        PersonalNotificationsListItemComponent,
    ],
    providers: [PersonalNotificationsService],
    exports: [PersonalNotificationsIconComponent],
})
export class PersonalNotificationsModule {}
